import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { FormGroup, Label } from '../formInputsV2/styles/common';
import { reactSelectStyles } from '../formInputsV2/reactSelectStyles';

function ReactSelecPublicoImpiego({
  label, options, values, error, valid, onChange,
}) {
  const [prepOptions, setPrepOptions] = useState([]);

  const handleChange = (value) => {
    if (value.type_of_organization !== undefined || value.type_of_organization !== '') {
      const typeEnte = options.find((opt) => opt.id == value.type_of_organization);
      if (typeEnte !== undefined) {
        onChange({
          type_of_organization: typeEnte.id,
        });
      }
    }

    if (value.type_of_organization === null || value.type_of_organization === '' || value.type_of_organization === undefined) {
      onChange({
        type_of_organization: '',
      });
    }
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.id, label: i.name })));
  }, [options]);

  return (
    <FormGroup>
      <Label>{label}</Label>
      <ReactSelect
        options={prepOptions}
        defaultOptions
        isSearchable
        placeholder=""
        value={options.filter((opt) => opt.id == values.type_of_organization).map((o) => ({ value: o.id, label: o.name }))[0]}
        onChange={(val) => {
          handleChange({
            type_of_organization: val === null || val === undefined ? '' : val.value,
          });
        }}
        loadingMessage={() => 'Caricando tipologie...'}
        clearValue
        isClearable
        noOptionsMessage={() => 'Tipologia non trovata!'}
        styles={reactSelectStyles({ error, valid })}
      />
      <div className="invalid-feedback">{error}</div>
    </FormGroup>
  );
}

export default ReactSelecPublicoImpiego;
